import { render } from "./signInUpLeft.vue?vue&type=template&id=aeee5528&scoped=true"
const script = {}

import "./signInUpLeft.vue?vue&type=style&index=0&id=aeee5528&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aeee5528"]])

export default __exports__